<template>
  <v-app id="login">
    <v-content>
      <v-container class="fill-height " fluid>
        <!-- <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">-->
        <v-card
          class="mx-auto mr-15  flex-row-reverse"
          outlined
          min-width="300"
          max-width="500"
          height="100%"
        >
          <div class="grey--text mt-5 d-inline-flex pa-2">
            <v-img width="75" height="75" src="@/assets/login.png"></v-img>
          </div>
          <v-toolbar
            class="mt-10 d-flex  justify-center "
            min-height="100"
            color="branco"
            flat
          >
            <v-toolbar-title color="primary"
              >Bem-vindo ao <v-spacer />
              Controle de Notas
            </v-toolbar-title>
            <v-spacer />
          </v-toolbar>

          <v-card-text>
            <v-form>
              <v-text-field
                class="black-text"
                label="Login"
                name="login"
                v-model="login.email"
                prepend-inner-icon="person"
                type="text"
                outlined
                dense
              />

              <v-text-field
                id="password"
                label="Senha"
                name="senha"
                v-model="login.senha"
                prepend-inner-icon="lock"
                type="password"
                outlined
                dense
              />
            </v-form>
          </v-card-text>
          <v-card-actions
            class="d-flex flex-column mb-6 d-flex  justify-center"
          >
            <v-spacer />
            <div class="">
              <div>
                <v-btn
                  tile
                  block
                  medium
                  :loading="loading"
                  class="ma-0 white--text"
                  @click="logar()"
                  color="botao_sucesso"
                  >Acessar</v-btn
                >

                <v-spacer />
              </div>
              <div class="grey--text pt-16 mt-15 d-inline-flex pa-2">
                <v-img src="@/assets/logo.png"></v-img>
              </div>
            </div>
          </v-card-actions>
        </v-card>
        <!-- </v-col>
        </v-row>-->

        <v-snackbar
          :timeout="tempo"
          :color="error"
          :multi-line="'multi-line'"
          :vertical="mode === 'vertical'"
          :top="true"
          v-model="snackbar"
        >
          {{ textSnack }}
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => {
    return {
      loading: false,
      login: {
        email: "",
        senha: "",
      },
      textSnack: "",
      snackbar: false,
      snackbarSuccess: false,
      tempo: 3000,
      mode: "",
      info: "f1f1f1",
      error: "error",
    };
  },
  methods: {
    async logar() {
      this.loading = true;
      //var self = axios;
      await axios
        .post(`users/login`, this.login)
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
            this.loading = false;
          } else {
            window.sessionStorage.setItem("token", response.data.token);
            window.sessionStorage.setItem("nome", response.data.nome);
            // EventBus.$emit("mudounome");
            window.sessionStorage.setItem("cnpj", response.data.cpf_cnpj);

            setTimeout(() => {
              //alert("abrir");
              /*self.default.headers.common["Authorization"] =
                "bearer " + window.sessionStorage.getItem("token");*/

              this.loading = false;
              this.$router.push("dashboard");
            }, 500);
            setTimeout(() => {
              //window.location.href = "dashboard";
            }, 1000);
            //return true;
          }

          //  console.log(response.data.token)
        })
        .catch((e) => {
          this.loading = false;
          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }

            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.data.error;
            this.snackbar = true;
          }
        });
    },
  },
};
</script>
<style scoped>
#login {
  background-image: url("~@/assets/fundo.png");
  background-size: cover;
  height: 100%;
}
</style>
